<template>
    <div>
        <header-nav :cur="4" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>&nbsp;
                    <span @click="back()">考试&nbsp;></span>
                    <span class="infor">考试详情</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">班级学习中心</div>
                        <div class="newbot">加入班级，更快速的成长</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text" />
                        <div class="select">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 学科分类 -->
        <div class="navtab">
            <div class="type bacground">
                <div class="ul">学科类型：&nbsp;</div>
                <ul>
                    <li v-for="(item, index) in xklx_list" :key="index" :class="{ color: index === int }" @click="clickParentSubject(index,item.wid)">{{ item.subjectName}}</li>
                </ul>
            </div>
            <div class="type" v-if="ejxk_list!=null">
                <div class="ul">学科名称：&nbsp;</div>
                <ul>
                    <li v-for="(item, index) in ejxk_list" :key="index" :class="{ color: index === subInt }" @click="clickSubSubject(index,item.wid)">{{ item.subjectName }}</li>
                </ul>
            </div>
        </div>
        <!-- 考试习题列表 -->
        <div class="navtab exerise">
            <div class="listbox" v-for="(item, index) in exercises" :key="index">
                <div class="name">{{ item.name }}</div>
                <div class="num">
                    总题数：{{ item.num }}题
                    <span>总分：{{ item.score }}分</span>
                </div>
                <div class="time">
                    答题时间：{{ item.time }}分钟
                    <span @click="toexercise(idItem)" v-if="idItem == 0 || idItem == 1">开始练习</span>
                    <span @click="toexercise(idItem)" v-if="idItem == 2 || idItem == 3">开始考试</span>
                </div>
            </div>
        </div>
        <!-- 分页 -->
        <paging />
        <footer-nav />
    </div>
</template>
<script>
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import paging from '../../components/Paging.vue';
export default {
    components: {
        headerNav,
        footerNav,
        paging,
    },
    data() {
        return {
            idItem: '',
            int: 0,
			subInt:0,
            order: ['最新教程', '最多学习', '好评最多'],
            exercise: [
                { name: '一级建造师模拟考试', num: 20, score: 100, time: 90 },
                { name: '一级建造师模拟考试', num: 20, score: 100, time: 90 },
                { name: '一级建造师模拟考试', num: 20, score: 100, time: 90 },
                { name: '一级建造师模拟考试', num: 20, score: 100, time: 90 },
                { name: '一级建造师模拟考试', num: 20, score: 100, time: 90 },
                { name: '一级建造师模拟考试', num: 20, score: 100, time: 90 },
                { name: '一级建造师模拟考试', num: 20, score: 100, time: 90 },
            ],
			xklx_list:'',
			ejxk_list:null,
			total:1,
			pageCount:1,
			pageSize:15,
			pageNum:1,
			subjectId:null,
			parentSubjectId:null,
			exercises:''
        };
    },
    mounted() {
        this.idItem = this.$route.query.id;
    },
	created() {
		this.queryParentSubjectList();
		this.queryExercises(1);
	},
    methods: {
		queryExercises(pageNum){
			this.$http.get(this.$api.url +'/papi/practice/list',{params:{'parentId':this.parentSubjectId,'subjectId':this.subjectId,'pageNum':pageNum,'pageSize':this.pageSize}}).then((response) => {
			    this.exercises=[];
				this.pageNum = pageNum;
			    this.exercises = response.data.rows;	
				this.total = response.data.total;
				if((this.total%this.pageSize)>0){
					this.pageCount = parseInt(this.total/this.pageSize)+1;
				}else{
					this.pageCount = this.total%this.pageSize;
				}
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
		queryParentSubjectList(){
			// Lambda写法
			this.$http.get(this.$api.url +'/papi/subject/queryParentSubjectList').then((response) => {
			    this.xklx_list=[];
			    this.xklx_list = response.data.data;	
			}, (response) => {
			    console.log("response"+response.data.length);
			});
			
		},
		querySubSubjectList(parentId){
			// Lambda写法
			this.$http.get(this.$api.url +'/papi/subject/querySubSubjectList',{params:{'parentId':parentId}}).then((response) => {
			    this.ejxk_list = response.data.data;	
			}, (response) => {
			    console.log("response"+response.data.length);
			});	
		},
        back() {
            this.$router.back(-1);
        },
        clickParentSubject(int,pid) {
            this.int = int;
			this.parentSubjectId=pid;
			this.querySubSubjectList(pid);
			this.queryExercises(1);
        },
		clickSubSubject(int,id) {
			this.subjectId=id;
		    this.subInt = int;
			this.queryExercises(1);
		},
        toexercise(id) {
            this.$router.push({ path: '/exam/exercise', query: { id: id } });
        },
    },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    // 搜索
    .nav {
        background: #f7f8fa;
        width: 100%;
        height: 177px;
        .top {
            display: block;
            font-size: 16px;
    
            font-weight: 300;
            color: #777777;
            padding: 19px 0 24px;
            span {
                cursor: pointer;
            }
            .infor {
                color: #2961EF;
            }
        }
        .newbox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .newtop {
                font-size: 26px;
                color: #000000;
                margin-bottom: 5px;
            }
            .newbot {
                font-size: 16px;
                color: #888888;
            }
            .input {
                width: 497px;
                height: 59px;
                background: #ffffff;
                box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
                border-radius: 30px;
                position: relative;
                input {
                    border: none;
                    position: absolute;
                    left: 30px;
                    top: 0;
                    height: 59px;
                    line-height: 59px;
                    width: 365px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #777777;
                }
                .select {
                    position: absolute;
                    right: 12px;
                    top: 8px;
                    width: 74px;
                    height: 43px;
                    line-height: 43px;
                    background: #2961EF;
                    border-radius: 30px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
    // 学科分类
    .bacground {
        background: #f7f8fa;
    }
    .type {
        margin: 27px 0 0;
        padding: 14px 17px;
    
        border-radius: 5px 5px 0px 0px;
        border: 1px solid #e3e8f2;
        .ul {
            font-size: 16px;
            color: #333333;
            display: inline-block;
            vertical-align: text-top;
            width: 7%;
            margin-top: 3px;
        }
        ul {
            display: inline-block;
            vertical-align: text-top;
            // float: right;
            width: 93%;
            li {
                display: inline-block;
                font-size: 16px;
                color: #888888;
                margin-right: 30px;
                line-height: 30px;
            }
        }
        .add {
            margin-top: 15px;
        }
        .addul {
            margin-top: 18px;
        }
    }
    .brder {
        border-top: none;
        margin: 0 0 21px;
        border-radius: 0px 0px 0px 0px;
        .ul {
            margin-top: 3px;
        }
        .add {
            margin: 0;
        }
    }
    // 考试习题列表
    .exerise {
        display: flex;
        flex-wrap: wrap;
        margin: 35px auto 56px;
        .listbox {
            width: 21.5%;
            margin-bottom: 27px;
            // height: 145px;
            background: #fafafa;
            border-radius: 0px 0px 5px 5px;
            border-top: 3px solid #2961EF;
            margin-right: 1%;
            padding: 17px;
            &:nth-child(4n) {
                margin-right: 0;
            }
            .name {
                font-size: 18px;
                font-weight: 600;
                color: #333333;
            }
            .num {
                height: 35px;
                line-height: 35px;
                background: #ffffff;
                border-radius: 5px 5px 5px 5px;
                font-size: 15px;
                color: #999999;
                padding: 0 10px;
                margin: 15px 0;
                span {
                    height: 35px;
                    line-height: 35px;
                    margin: 0 0 0px 40px;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: -20px;
                        top: 2px;
                        display: inline-block;
                        width: 1px;
                        height: 16px;
                        background: #999999;
                    }
                }
            }
            .time {
                padding: 0 10px;
                font-size: 15px;
                color: #888888;
                span {
                    cursor: pointer;
                    font-size: 16px;
                    color: #2961EF;
                    float: right;
                }
            }
        }
    }
    
</style>